module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab"
  }, [_c('wb-datatable', _vm._b({
    attrs: {
      "searchKey": 'email'
    },
    on: {
      "addEmit": _vm.openCreateDialog,
      "editEmit": _vm.openUpdateDialog,
      "deleteEmit": _vm.openConfirmDialog
    }
  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "updateDialog"
  }, [_c('md-dialog-title', [_vm._v("Update User Teams")]), _vm._v(" "), _c('md-dialog-content', {
    staticStyle: {
      "height": "1024px"
    }
  }, [(_vm.user) ? _c('div', [_c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("User name")]), _vm._v("\n          " + _vm._s(_vm.user.username) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.email) + "\n        ")]), _vm._v(" "), (_vm.user.team) ? _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Team:")]), _vm._v("\n          " + _vm._s(_vm.user.team) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
    staticClass: "md-has-value"
  }, [_c('label', [_vm._v("Expired Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "name": "uniquename",
      "clear-button": true
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeUpdateDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeUpdateDialog(true)
      }
    }
  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you want to remove this user from the assigned\n      team?")]), _vm._v(" "), _c('md-dialog-content', [(_vm.user) ? _c('form', [_c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("User name")]), _vm._v("\n          " + _vm._s(_vm.user.username) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.email) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Email")]), _vm._v("\n          " + _vm._s(_vm.user.team) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "createDialog"
  }, [_c('md-dialog-title', [_vm._v("Create team assignment")]), _vm._v(" "), _c('md-dialog-content', {
    staticStyle: {
      "height": "1024px"
    }
  }, [_c('div', [_c('md-input-container', [_c('multiselect', {
    attrs: {
      "id": "users",
      "options": _vm.usersCopy,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "placeholder": "Email",
      "label": "email"
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  })], 1), _vm._v(" "), _c('md-checkbox', {
    staticClass: "all-teams-checkbox",
    model: {
      value: (_vm.allTeams),
      callback: function($$v) {
        _vm.allTeams = $$v
      },
      expression: "allTeams"
    }
  }, [_vm._v("\n          Assign to all teams\n        ")]), _vm._v(" "), _c('md-input-container', {
    staticClass: "mt-0 pt-0"
  }, [_c('multiselect', {
    attrs: {
      "disabled": _vm.allTeams,
      "id": "teamName",
      "options": _vm.userTeams,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "placeholder": "Team",
      "label": "name"
    },
    model: {
      value: (_vm.selectedTeam),
      callback: function($$v) {
        _vm.selectedTeam = $$v
      },
      expression: "selectedTeam"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    staticClass: "md-has-value"
  }, [_c('label', [_vm._v("Expired Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "name": "uniquename",
      "clear-button": true
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.isNew ? "Create" : "Update"))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f2b02ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminUsersTeam.vue
// module id = 301
// module chunks = 2